import { useState, useEffect } from 'react';
import { getApiUrl } from '../config/demoMode';

/**
 * Giriş ve hata sayfalarının markası.
 *
 * Kullanıcı henüz oturum açmadığı için otel adı bilinmez (bir hesabın birden
 * fazla oteli olabilir). Marka, isteğin alan adına bakılarak müşteri kaydından
 * çözülür: `GET api/public/marka`. Uç yanıt vermezse ürün adına düşülür,
 * sayfa yine de açılır.
 */

const VARSAYILAN = { ad: 'HotelFlow', logoUrl: null, demoMu: false };

// Aynı oturumda her sayfa açılışında yeniden istek atılmasın
let onbellek = null;

export default function useMarka() {
  const [marka, setMarka] = useState(onbellek || VARSAYILAN);

  useEffect(() => {
    if (onbellek) return;

    const apiUrl = getApiUrl();
    if (!apiUrl) return;

    let iptal = false;
    fetch(`${apiUrl}/public/marka`, { credentials: 'include' })
      .then(r => (r.ok ? r.json() : null))
      .then(d => {
        if (iptal || !d?.ad) return;
        onbellek = { ad: d.ad, logoUrl: d.logoUrl || null, demoMu: !!d.demoMu };
        setMarka(onbellek);
      })
      .catch(() => {});   // marka alınamazsa varsayılanla devam

    return () => { iptal = true; };
  }, []);

  return marka;
}
